import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M480.285714,822.857143 L1028.85714,822.857143 C1180.12571,822.857143 1303.14286,699.84 1303.14286,548.571429 C1303.14286,397.302857 1180.12571,274.285714 1028.85714,274.285714 L480.285714,274.285714 L480.285714,822.857143 Z M480.285714,1645.71429 L1166,1645.71429 C1317.26857,1645.71429 1440.28571,1522.69714 1440.28571,1371.42857 C1440.28571,1220.16 1317.26857,1097.14286 1166,1097.14286 L480.285714,1097.14286 L480.285714,1645.71429 Z M1166,1920 L206,1920 L206,0 L1028.85714,0 C1331.39429,0 1577.42857,246.034286 1577.42857,548.571429 C1577.42857,682.834286 1528.88,805.988571 1448.65143,901.302857 C1607.87429,997.44 1714.57143,1172.29714 1714.57143,1371.42857 C1714.57143,1673.96571 1468.53714,1920 1166,1920 L1166,1920 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBoldSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconBoldSolid, _Component);

  var _super = _createSuper(IconBoldSolid);

  function IconBoldSolid() {
    _classCallCheck(this, IconBoldSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconBoldSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBold",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBoldSolid.displayName = "IconBoldSolid";
  return IconBoldSolid;
}(Component);

IconBoldSolid.glyphName = 'bold';
IconBoldSolid.variant = 'Solid';
IconBoldSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBoldSolid;
export { IconBoldSolid };